var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4291 31.9254C10.1106 28.4417 9.54628 23.0042 12.0723 18.8521L20.4997 5L28.9276 18.8522C31.4537 23.0042 30.8895 28.4417 27.5709 31.9254C23.6658 36.0249 17.3343 36.0248 13.4291 31.9254Z",
    stroke: "#5663F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18L20.5 24",
    stroke: "#5663F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 28.5,
    r: 1.5,
    fill: "#5663F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLiquidity);
export default __webpack_public_path__ + "static/media/NoLiquidity.154788974af9a01bb0e8cc25e785777c.svg";
export { ForwardRef as ReactComponent };